import { createSlice } from '@reduxjs/toolkit';

const staffSlice = createSlice({
  name: 'MathsStaff',
  initialState: {
    staffData: null,
    staffExists: false,
    isStaffAdmin: false,
  },
  reducers: {
    setStaffData: (state, action) => {
      state.staffData = action.payload.staffData;
      state.staffExists = action.payload.staffExists;
      state.isStaffAdmin = action.payload.isStaffAdmin;
    },
    resetStaff: (state) => {
      state.staffData = null;
      state.staffExists = false;
      state.isStaffAdmin = false;
    },
  },
});

export const { setStaffData, resetStaff } = staffSlice.actions;

export const selectStaffData = (state) => state.staff.staffData;
export const selectStaffExists = (state) => state.staff.staffExists;
export const selectIsStaffAdmin = (state) => state.staff.isStaffAdmin;

export default staffSlice.reducer;
